module.exports = __webpack_public_path__ + "media/application/images/svgs/cpu-eb0f622a8b2c6a7b45ff80e429f4712c.svg";